module.exports = __webpack_public_path__ + "img/consult_info2.de4fe745.png";